import React, { useState } from "react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { SheetContainer, Text } from "@bookingcom/bui-react";
export const FlightCardBadgeBottomSheetWrapper = ({ hover, children }) => {
    const i18n = useI18n();
    const [isBottomSheetActive, setBottomSheetActive] = useState(false);
    if (!hover)
        return React.createElement(React.Fragment, null, children);
    return (React.createElement("span", { role: "presentation", onClick: (event) => {
            event.stopPropagation();
            event.preventDefault();
        } },
        React.createElement("div", { role: "button", tabIndex: 0, onClick: () => setBottomSheetActive(true) }, children),
        React.createElement(SheetContainer, { active: isBottomSheetActive, onCloseTrigger: () => setBottomSheetActive(false), closeAriaLabel: i18n.trans(t("close")), position: "bottom", title: hover.title },
            React.createElement(Text, null, hover.text))));
};
